import React from "react"

import { NotificationManager } from "react-notifications"

import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/solid"

import classNames from "src/classNames"

import { gql, useMutation } from "hooks/urql"

export type HideButtonProps = {
  messageThreadId: string
  hidden: boolean
}

const HideButton: React.FC<HideButtonProps> = ({ messageThreadId, hidden }) => {
  const [, runMutation]: any[] = useMutation(hideThreadMutation)

  const hideThread = () => {
    runMutation({ messageThreadId, hide: !hidden })
      .then(
        result => {
          const { failures } = result.data.hideMessageThread
          if (failures.length > 0) {
            NotificationManager.error(failures[0].message)
          } else {
            NotificationManager.success(
              `This thread is now ${hidden ? "visible" : "hidden"}`
            )
          }
        },
        () => NotificationManager.error("Something went wrong")
      )
      .catch(() => NotificationManager.error("Something went wrong"))
  }
  return (
    <button
      className={classNames(
        "mb-4 flex cursor-pointer items-center justify-center rounded-md border-4 border-solid border-brand p-2 font-semibold uppercase focus:outline-none",
        hidden
          ? "!bg-brand-600 text-white hover:!bg-transparent hover:!text-brand-600"
          : "bg-transparent text-brand-600 hover:!bg-brand-600 hover:text-white"
      )}
      onClick={hideThread}
    >
      {hidden ? "Make Thread Visible" : "Hide Thread"}
      {hidden ? (
        <EyeIcon className="ml-2 h-6 w-6" />
      ) : (
        <EyeSlashIcon className="ml-2 h-6 w-6" />
      )}
    </button>
  )
}

const hideThreadMutation = gql`
  mutation HideThread($messageThreadId: ID!, $hide: Boolean!) {
    hideMessageThread(messageThreadId: $messageThreadId, hide: $hide) {
      failures {
        message
      }
      messageThread {
        id
      }
    }
  }
`
export default HideButton
